
import { Component, effect, input } from "@angular/core";
import { PlayAudioService } from "../../../../../services/playaudio.service";

@Component({
  selector: 'app-audio-btn',
  templateUrl: './audio-btn.component.html',
  styleUrls: ['./audio-btn.component.scss'],
  imports: []
})
export class AudioBtnComponent {
  public readonly msg = input.required<string>();
  public readonly botId = input.required<string>();
  public readonly voice = input<string>();
  public readonly demoURL = input<string>('');
  public readonly isDisabled = input<boolean>(false);
  public readonly isVoiceTester = input<boolean>(false);
  public readonly voiceTesterIdentifier = input<string>('');
  public hash: string = '';

  constructor(public playService: PlayAudioService) {
    effect(() => { this.hash = this.playService.getHashFromText(this.msg()); });
  }

  public getState() {
    if (this.isPlaying()) {
      return "play";
    }
    if (this.isLoading()) {
      return "load";
    }
    return "idle";
  }

  public isLoading() {
    if (this.playService.currentLoadingHash == "") {
      return false;
    }
    return this.playService.currentLoadingHash == this.hash;
  }

  public isPlaying() {
    if (this.playService.currentPlayingHash == "") {
      return false;
    }
    return this.playService.currentPlayingHash == this.hash;
  }

  public async playAudio() {
    const demoURL = this.demoURL();
    if (this.isVoiceTester() && demoURL !== '') {
      this.playService.removeHashFromDict(this.hash);
      this.hash = this.playService.getHashFromText("DemoText" + this.voiceTesterIdentifier());
      this.playService.isVoiceTester = true;
      await this.playService.playDemoAudio("DemoText" + this.voiceTesterIdentifier(), demoURL);
    } else {
      await this.playService.playAudio(this.msg(), this.botId(), this.voice());
    }
  }

  public stopAudio() {
    this.playService.stopAudio();
  }
}
